<template>
    <v-card-title flat color="white" class="justify-center bottom-sheet-header" style="">
        <slot />
    </v-card-title>
</template>

<script>
export default {};
</script>


<style lang="scss" scoped>
.bottom-sheet-header {
    background-color: #666;
    color: #fff;
    font-size: 1.6rem;
    font-weight: 700;
    height: 48px;
    border-radius: 16px 16px 0 0;
}
</style>